import { jsx as _jsx } from "react/jsx-runtime";
import s from './tab.module.scss';
export var Tab = function (_a) {
    var text = _a.text;
    return (_jsx("div", { className: s.tab, children: text }));
};
